// SPEC-UX-COMPASSO.md §3.6: motivo + caminho. O core lança código; a UI
// traduz. Nunca texto de usuário no core (SPEC-COMPASSO-v3.md §D5).
const MENSAGENS: Record<string, string> = {
  TRANSICAO_INVALIDA: 'Esta ação não está disponível no estado atual.',
  JUSTIFICATIVA_OBRIGATORIA: 'Esta ação exige uma justificativa.',
  ERR_I1_BLUEPRINT_AUSENTE: 'Selecione um blueprint antes de continuar.',
  ERR_I2_SEM_CAPACIDADE: 'Não há capacidade disponível para os recursos exigidos.',
  ERR_I3_SEM_RESPONSAVEL: 'Defina um responsável antes de continuar.',
  ERR_I4_SEM_DATA_VALIDACAO: 'Informe a data de validação da premissa.',
  ERR_I5_PROJETO_ABERTO: 'Há projetos ainda abertos neste programa.',
  ERR_I6_BENEFICIO_ABERTO: 'Há benefícios ainda em aberto neste programa.',
  ERR_I7_DEPENDENCIA_NAO_CUMPRIDA: 'Uma dependência bloqueante ainda não foi cumprida.',
  ERR_I8_SOBREALOCACAO: 'Esta alocação sobrecarrega o recurso além do disponível.',
  ERR_I9_ESCRITA_DERIVADO: 'Este valor é calculado automaticamente e não pode ser editado.',
  ERR_I10_PUBLICADO_IMUTAVEL: 'Blueprints publicados não podem ser editados — crie uma nova versão.',
  ERR_I11_ATIVIDADE_ABERTA: 'Há atividades ainda abertas nesta fase.',
  ERR_I12_ATIVIDADE_INVALIDA: 'Esta atividade não aceita a ação no estado atual.',
  ERR_I13_DEPENDENCIA_DUPLICADA: 'Esta dependência já está registrada.',
  ERR_I15_SEM_BASELINE: 'Informe os dados da baseline antes de aprovar.',
  ERR_I16_SEM_ASSESSMENT: 'Avalie o impacto nos projetos dependentes antes de aprovar.',
  VEREDICTO_EXPIRADO: 'O veredito de capacidade expirou — recalcule antes de autorizar.',
  BLUEPRINT_SEM_SKILL: 'Toda fase precisa de ao menos uma skill exigida.',
  BLUEPRINT_SEM_GATE: 'Toda fase precisa de ao menos um critério de gate obrigatório.',
  GRAFO_COM_CICLO: 'Esta dependência criaria um ciclo no grafo do programa.',
  TETO_EXCEDIDO: 'Esta ação excede o teto de capacidade do portfólio.',
  NAO_ENCONTRADO: 'Não encontrado.',
  PERMISSAO_NEGADA: 'Você não tem permissão para esta ação.',
};

export function mensagemDeErro(codigo: string): string {
  return MENSAGENS[codigo] ?? 'Não foi possível concluir a ação.';
}
